import React from 'react';
import PropTypes from 'prop-types';

import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';

import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';
import CriteriumSnippetElement from '@hydra/common/criterium/CriteriumSnippetElement';
import Translate from '@hydra/common/components/i18n';

export const LargestContentfulPaintElement = ({ criterium }) => {
  const { data } = criterium;
  const { nodes } = data;

  const rows = nodes
    .slice(0, 1)
    .map(({ snippet, nodeLabel }, i) => {
      return [
        <CriteriumSnippetElement key={`element-${i}`} snippet={snippet} nodeLabel={nodeLabel} />
      ];
    });

  const content = (
    <>
      <Translate content='largest_contentful_paint_element_summary' />
      {nodes[0] && nodes[0].isImage && !nodes[0].isPreloaded && (
        <CriteriumIconAndText
          success={false}
          text={<Translate content='largest_contentful_paint_element_not_preloaded' />}
        />
      )}
      <CriteriumTable
        head={['']}
        rows={rows}
      />
    </>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

LargestContentfulPaintElement.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          snippet: PropTypes.string,
          nodeLabel: PropTypes.string,
          isImage: PropTypes.bool,
          isPreloaded: PropTypes.bool
        })
      )
    })
  })
};

export default React.memo(LargestContentfulPaintElement);
